<template>
  <div class="translate-wrapper">
    <ValidationObserver
      ref="validationObserver"
      v-slot="{ handleSubmit }"
    >
      <form
        class="contact-info"
        novalidate="novalidate"
        @submit.prevent="handleSubmit(submit)"
        @input="handleFormChange"
      >
        <div class="poster-title">
          Banner Image (16:9)
        </div>
        <PosterImage
          ref="bannerImage16x9"
          :key="formData.bannerImage16x9"
          :poster="formData.bannerImage16x9"
          :onPosterChange="handleBannerImage16x9Change"
          :isNeedRemove="true"
        />
        <div class="banner-wrapper banner-2x3-wrapper">
          <div class="poster-title">
            Banner Image (2:3)
          </div>
          <PosterImage
            ref="bannerImage2x3"
            :key="formData.bannerImage2x3"
            :poster="formData.bannerImage2x3"
            :isPoster2x3="true"
            :onPosterChange="handleBannerImage2x3Change"
            :isNeedRemove="true"
          />
        </div>
        <div class="btn-wrapper">
          <div class="btn-wrapper-b">
            <Button
              type="submit"
              :title="'Apply Changes'"
              :classType="'primary'"
            />
            <Button
              :title="'Revert'"
              :classType="'warning'"
              :eventFunction="revertLanguage"
            />
          </div>
          <div
            v-if="isEditedForm.length
              && isEditedForm.find(item => item.id === lang.id && !!item.value)"
            class="changes-wrapper"
          >
            <inline-svg
              :src="iconChanges"
              class="svg-icon"
            >
            </inline-svg>
            <span class="changes-text">
              Unsaved changes
            </span>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseForm from '../BaseForm.vue';
import Button from '../../common/Button.vue';
import iconChanges from '../../../assets/icons/icon-localization-changes.svg';
import PosterImage from '../../common/PosterImage/DragAndDropFileUploader.vue';

import {
  ADD_LANGUAGE_BANNERS_REQUEST,
  GET_LANGUAGE_BANNERS_REQUEST,
  INIT_FORM_CHANGES,
  SET_FORM_CHANGES,
} from '../../../store/actions/localization/localizationActions';

export default {
  name: 'BannerV2LocalizationForm',
  components: {
    PosterImage,
    Button,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'cmsManuallyLocalization',
    },
    lang: {
      type: Object,
      default: () => {},
    },
    banner: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
    changedLanguage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      iconChanges,
      submitEvent: ADD_LANGUAGE_BANNERS_REQUEST,
      successMessages: `The ${this.lang.name} Localization has been successfully updated`,
      isBannerImage16x9Changed: false,
      isBannerImage2x3Changed: false,
      formData: {
        bannerImage16x9: '',
        bannerImage2x3: '',
      },
      formFields: {
        label: {
          type: 'text',
          name: 'label',
          formPrefix: this.formPrefix,
          rules: {
            required: false,
            max: 25,
          },
        },
      },
      errorMapping: {
        label: [
          `${this.formPrefix}.label`,
        ],
      },
    };
  },
  computed: {
    ...mapState({
      isEditedForm: (state) => state.localization.isEditedForm,
      bannerLanguage: (state) => state.localization.bannerLanguage,
    }),
    ...mapGetters([
      'getCurrentAccountId',
      'isThemeBasic',
    ]),
  },
  created() {
    const value = this.languages.map(((item) => ({
      id: item.id,
      value: false,
    })));
    this.$store.dispatch(INIT_FORM_CHANGES, value);

    const params = {
      accountId: this.getCurrentAccountId,
      bannerId: this.banner && this.banner.id,
      langId: this.lang.id,
    };
    this.$store.dispatch(GET_LANGUAGE_BANNERS_REQUEST, params).then((res) => {
      this.initFormData(res);
    });
  },
  beforeDestroy() {
    this.$store.dispatch(SET_FORM_CHANGES, []);
  },
  methods: {
    handleFormChange() {
      this.$emit('changedLanguage', { id: this.lang.id, value: true });
    },
    handleBannerImage16x9Change(img) {
      this.isBannerImage16x9Changed = true;
      this.handleFormChange();
      this.formData.bannerImage16x9 = img;
    },
    handleBannerImage2x3Change(img) {
      this.isBannerImage2x3Changed = true;
      this.handleFormChange();
      this.formData.bannerImage2x3 = img;
    },
    initFormData(data) {
      this.formData.bannerImage16x9 = data.bannerImage16x9
        ? `${data.bannerImage16x9}?height=360`
        : '';

      this.formData.bannerImage2x3 = data.bannerImage2x3
        ? `${data.bannerImage2x3}?height=360`
        : '';
    },
    revertLanguage() {
      const params = {
        accountId: this.getCurrentAccountId,
        bannerId: this.banner && this.banner.id,
        langId: this.lang.id,
      };
      this.$store.dispatch(GET_LANGUAGE_BANNERS_REQUEST, params).then((res) => {
        this.$emit('changedLanguage', { id: this.lang.id, value: false });
        this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
        this.isBannerImage16x9Changed = false;
        this.isBannerImage2x3Changed = false;
        this.initFormData(res);
      });
    },
    getRequestData() {
      const data = {};

      if (this.isBannerImage16x9Changed) {
        data.bannerImage16x9 = this.formData.bannerImage16x9;
      }

      if (this.isBannerImage2x3Changed) {
        data.bannerImage2x3 = this.formData.bannerImage2x3;
      }

      return {
        accountId: this.getCurrentAccountId,
        bannerId: this.banner && this.banner.id,
        langId: this.lang.id,
        data,
      };
    },
    onSubmitSuccess() {
      this.isBannerImage16x9Changed = false;
      this.isBannerImage2x3Changed = false;
      this.$emit('changedLanguage', { id: this.lang.id, value: false });
      this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
      this.$toasted.global.success({
        message: this.successMessages,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.poster-title {
  color: #fff;
  font-weight: normal;
  margin-bottom: 10px;
}

.btn-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding-top: 35px;
}

.changes-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #FB3951;
  border-radius: 2px;
  padding: 8px;
  color: #FB3951;
  margin-left: 20px;
}

.banner-wrapper {
  margin-top: 30px;
}

.banner-2x3-wrapper {
  max-width: 260px;
}

.changes-text {
  padding-left: 5px;
}

.btn-wrapper-b {
  display: flex;
}
</style>
